<template>
<Box @close="close(false)">
    <template #top>Nueva Transferencia: Orden Compra</template>
    <template #center>
        <div class="nj-panel">
            <div class="nj-panel-content">
                <div class="nj-grid">
                    <SearchBox label="N° Orden" v-model="transferencia_items.ord_id" itemKey="ord_id" itemValue="ord_id" :source="ordenes" :labelFunction="(item) => item.ord_code" id="tc-orden"
                        :searchFunction="buscarOrden" @selectItem="buscarItems" :disabled="disabled_numero_orden" @input="reset($event)">
                        <template #default="data">
                            {{ data.item.ord_code }}
                        </template>
                    </SearchBox>
                    <InputSelect label="Almacen destino" v-model="transferencia_items.alm_destino" id="toc-almacen-destino" :source="almacenes" itemKey="alm_id" itemValue="alm_id"
                        :filterFunction="filterAlmacen" :labelFunction="labelAlmacen">
                        <template #default="data">
                            {{ labelAlmacen(data.item) }}
                        </template>
                    </InputSelect>
                    <InputDate label="Fecha de llegada" v-model="transferencia_items.tfi_fecha_estimada_llegada_date"></InputDate>
                </div>
                <br>
                <b-table :data="transferencia_items.lista_transferencia_items_detalle" :sort-icon="sortIcon" :sort-icon-size="sortIconSize">
                    <template slot-scope="props">
                        <b-table-column style="vertical-align: middle;" label="Producto" header-class="is-info">{{ props.row.oci_descripcion }}</b-table-column>
                        <b-table-column style="vertical-align: middle;" label="Cantidad comprada" header-class="is-info">{{ props.row.oci_cantidad }}</b-table-column>
                        <b-table-column style="vertical-align: middle;" label="Cantidad transferida" header-class="is-info">{{ props.row.tid_total }}</b-table-column>
                        <b-table-column style="vertical-align: middle;" label="Saldo" header-class="is-info">{{ props.row.oci_saldo_transferencia }}</b-table-column>
                        <b-table-column style="vertical-align: middle; width: 100px;" label="Cantidad" header-class="is-info">
                            <input type="text" class="nj-text" v-model="props.row.tid_cantidad" :disabled="props.row.oci_saldo_transferencia == 0">
                        </b-table-column>
                    </template>
                </b-table>
            </div>
        </div>
    </template>
    <template #bottom>
        <Button icon="save" label="Registrar" @click="registrar()"></Button>
    </template>
</Box>
</template>

<script>
import { OrdenCompraService, ResponseStatus, TransferenciaItemsService, UsuarioService } from "../../rest"
import { Acceso, Data, DateTime, Validator } from "../../util"
import Toast from "../../util/toast"
import { Box, Button, InputDate, InputSelect, InputText, SearchBox } from "../components"

export default {
    name: "TransferenciaOrdenCompra",
    components: {
        Box,
        Button,
        InputSelect,
        SearchBox,
        InputText,
        InputDate,
    },
    props: {
        ord_id: {
            type: Number,
            default: null
        },
        pry_id: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            orden: {
                ord_id: null
            },
            disabled_numero_orden: false,
            transferencia_items: {
                ord_id: null,
                tfi_usu_registrador: UsuarioService.getUsuario().usu_id,
                tfi_tipo: 1, // transferencia: orden de compra
                tfi_fecha_estimada_llegada: null,
                alm_destino: null,
                lista_transferencia_items_detalle: []
            },
            almacenes: [],
            ordenes: [],
            alm_nombre: null,
            ord_code: null,
            sortIcon: "arrow-up",
            sortIconSize: "is-small",
        }
    },
    methods: {
        registrar() {
            if (
                Validator.start(
                    this.transferencia_items.alm_destino,
                    this.transferencia_items.ord_id,
                    this.transferencia_items.tfi_fecha_estimada_llegada_date,
                )) {
                TransferenciaItemsService
                    .registrar(this.transferencia_items)
                    .then(response => {
                        if (ResponseStatus.isSuccess(response)) {
                            Toast.success(response.message)
                            this.close(true)
                        }
                        else {
                            Toast.warn(response.message)
                        }
                    })
                    .catch(error => {
                        Toast.error(error)
                    })
            }
            else {
                Toast.warn("Falta ingresar algunos datos para registrar la transferencia")
            }
        },
        reset(value) {
            if (value == null) {
                this.transferencia_items.lista_transferencia_items_detalle = []
            }
        },
        close(buscar) {
            this.$emit("close", {
                interfaz: "TransferenciaOrdenCompra",
                activar: false,
                buscar,
            })
        },
        filterAlmacen(items, param) {
            if (param != null && param != "") {
                return items.filter(item => `${item.pry_nombre} | ${item.alm_nombre}`.toLowerCase().includes(param.toLowerCase()))
            }
            else {
                return items
            }
        },
        buscarOrden(ord_code) {
            if (ord_code != null && ord_code != "") {
                OrdenCompraService
                    .buscar({
                        orden_compra: {
                            ord_code
                        }
                    })
                    .then(response => {
                        this.ordenes = response.data
                    })
                    .catch(error => {
                        Toast.error(error)

                    })
            }
            else {
                Toast.warn("Debe ingresar alguna referencia de la orden")
            }
        },
        buscarItems() {
            this.transferencia_items.lista_transferencia_items_detalle = []
            OrdenCompraService
                .obtenerDetallexTransferencia({
                    orden_compra: {
                        ord_id: this.transferencia_items.ord_id
                    }
                })
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        const data = response.data
                        data.forEach(item => {
                            this.transferencia_items.lista_transferencia_items_detalle.push({
                                oci_descripcion: item.oci_descripcion,
                                prv_id: item.prv_id,
                                oci_cantidad: item.oci_cantidad,
                                tid_total: item.tid_total,
                                oci_saldo_transferencia: item.oci_saldo_transferencia,
                                tid_cantidad: item.oci_saldo_transferencia,
                            })
                        })
                    }
                    else {
                        Toast.warn(response.message)
                    }
                })
                .catch(error => {
                    Toast.error(error)
                })
        },
        labelAlmacen(almacen) {
            return `${almacen.pry_nombre} | ${almacen.alm_nombre} ${almacen.alm_tipo == 0 ? "*" : ""}`
        },
    },
    mounted() {
        this.transferencia_items.tfi_fecha_estimada_llegada_date = DateTime.getDateString()
        this.almacenes = Data.getAlmacenes()
        // verificando si la solicitud de generar la transferencia viene de la vista de Orden Compra
        if (this.ord_id != null && this.pry_id != null) {
            // colocando por detras el id de la orden
            this.transferencia_items.ord_id = this.ord_id
            // colocando el primer almacen del proyecto
            this.almacenes = this.almacenes.filter(item => item.pry_id == this.pry_id)
            this.transferencia_items.alm_destino = Validator.start(this.almacenes)
                ? this.almacenes[0].alm_id
                : []
            this.disabled_numero_orden = true
            // buscando los items asociados a la orden de compra
            this.buscarItems()
        }
    }
}
</script>

<style scoped></style>